var 
  group = {a:"aàáâãäå",c:"cç",e:"eéèëê",i:'iíìïî',n:'nǹńñṅň', o:'oóòõöô',u:'uúùüû'},
  needRegExpEscape = "\\()[]{}.*+?|^$";

export class Searcher{
  constructor(){
    this.getRegExp = function(part){
      var result = '';
      for(var i=0;i<part.length;i++){
        var char = part.charAt(i);
        if(group[char]){
          result += '['+group[char]+']'
        }else if(needRegExpEscape.indexOf(char)>-1){
          result += '\\'+char
        }else{
          //todo escape for regexp
          result += char
        }
      }
      //search begin of word, global ignorecase
      return new RegExp("(^|\\W)"+result, "gi");
    }
  }
  search(part,text){
    var theRegExp = this.getRegExp(part)
    return text.match(theRegExp);
  }
  filter(part,texts){
    var theRegExp = this.getRegExp(part)
    return texts.filter(text=>text.match(theRegExp))
  }
  score(part,texts){
    var 
      theRegExp = this.getRegExp(part),
      scored = texts.map(text=>{
        var matches = text.match(theRegExp);
        if(matches){
          return {text:text,score:text.indexOf(matches[0])}
        }else{
          return null
        }
      }).filter(sub=>sub!==null);
    return scored;
  }
  filterSuggestion(part,suggestionBeans){
    var 
      theRegExp = this.getRegExp(part),
      result = [];
    suggestionBeans.forEach(sugg=>{
      if(sugg.value.match(theRegExp)){
        result.push(sugg)
      }else if(sugg.alternates){
        for(let i=0;i<sugg.alternates.length;i++){
          if(sugg.alternates[i].match(theRegExp)){
            result.push(sugg);
            break;
          }
        }
      }
    });
    return result;
  
  }
}